import { ApplicationProcessBlockData } from "@/storyblok/schemas";
import { makeEditable } from "@/storyblok/visual-editor";
import IconApplicationStep1 from "../icons/IconApplicationStep1";
import IconApplicationStep2 from "../icons/IconApplicationStep2";
import IconApplicationStep3 from "../icons/IconApplicationStep3";
import IconApplicationStep4 from "../icons/IconApplicationStep4";
import IconApplicationStep5 from "../icons/IconApplicationStep5";
import { resolveSectionClasses } from "@/storyblok/resolvers";

export default function ApplicationProcess({
  data,
}: {
  data: ApplicationProcessBlockData;
}) {
  return (
    <section
      id={data.anchor}
      className="section--application-process"
      {...makeEditable(data)}
      style={{ "--color-background": data.background_color?.color }}
    >
      <div className={resolveSectionClasses(data, "container")}>
        <div className="container">
          <div className="col">
            <h3>{data.title}</h3>
            <p>{data.content}</p>
          </div>
        </div>
        <ul>
          {data.cv_label && (
            <li>
              <IconApplicationStep1 />
              <p>{data.cv_label}</p>
            </li>
          )}
          {data.recruiter_label && (
            <li>
              <IconApplicationStep2 />
              <p>{data.recruiter_label}</p>
            </li>
          )}
          {data.colleagues_label && (
            <li>
              <IconApplicationStep3 />
              <p>{data.colleagues_label}</p>
            </li>
          )}
          {data.assessment_label && (
            <li>
              <IconApplicationStep4 />
              <p>{data.assessment_label}</p>
            </li>
          )}
          {data.success_label && (
            <li>
              <IconApplicationStep5 />
              <p>{data.success_label}</p>
            </li>
          )}
        </ul>
        <div className="btn_row">
          {data.button && (
            <a className="btn" href={`#${data.button.anchor}`}>
              {data.button.label}
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
